<template>
    <client-page>

        <sub-visual
        sh="What We Do"
        tabActive="Smart Factory"
        bg="/images/sub/visual/sv4.png">
        </sub-visual>

        <section class="sub-section sub-section--first">
            <v-container>
                <div class="page-tit-wrap">
                    <h2 class="page-tit">
                        Smart Factory
                    </h2>
                    <p>
                        생산과정에 디지털 자동화 솔루션이 결합된 정보통신기술 (ICT)를 적용하여 <br class="d-none d-md-block">
                        loT를 통해 공정 데이터를 실시간 수집하고 스스로 분석하는 공정 도입
                    </p>
                </div>
            </v-container>
        </section>

        <section class="sub-section">
            <v-container>
                <sub-line-layout tit="현장 데이터 집계">
                    <v-img src="/images/sub/wwd/factory/factory-img1.png" max-width="946" class="mx-auto d-none d-md-block"></v-img>
                    <v-img src="/images/sub/wwd/factory/factory-img1-mo.png" max-width="484" class="mx-auto d-block d-md-none"></v-img>
                </sub-line-layout>
            </v-container>
        </section>

        <section class="sub-section sub-section--last">
            <v-container>
                <sub-line-layout tit="데이터 집계 부서">
                    <v-img src="/images/sub/wwd/factory/factory-img2.png" max-width="896" class="mx-auto d-none d-md-block"></v-img>
                    <v-img src="/images/sub/wwd/factory/factory-img2-mo.png" max-width="624" class="mx-auto d-block d-md-none"></v-img>
                </sub-line-layout>
            </v-container>
        </section>

    </client-page>
</template>

<script>
import ClientPage from "@/pages/client/ko/templates/ClientPage.vue";
import SubVisual from "@/components/client/ko/sub/sub-visual.vue";
import SubLineLayout from "@/components/client/ko/sub/sub-line-layout.vue";
export default {
    components: {
        ClientPage,
        SubVisual,
        SubLineLayout,
    },
};
</script>

<style lang="scss" scoped>
</style>